import { render, staticRenderFns } from "./CtrlJigyosho.vue?vue&type=template&id=b00dc546&scoped=true&"
import script from "./CtrlJigyosho.vue?vue&type=script&lang=ts&"
export * from "./CtrlJigyosho.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00dc546",
  null
  
)

export default component.exports